import React from "react";
import {translateStatusService} from "../../jwt/_services/configuration/translateStatusService";

export const translateStatusProvider = {
    getOptions,
};

async function getOptions(){
    try {
        const listItems = await translateStatusService.getOptions();

        return listItems.map((itemData) => {
            const { id, code, description } = itemData
            return (
                {
                    id: id,
                    value: code,
                    label: <div><label>{description}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}